<template>
  <div class="h-100 w-75 px-5 py-2 main">
    <h1><a name="_Toc63679333" />COOKIES-POLICY</h1>
    <p>&nbsp;</p>
    <p>Zimmer &amp; Peacock AS (org. no. 917 749 329) ("<strong>ZP</strong>") uses cookies and other information gathering methods to enhance the user experience and obtain information about your use of our website. Cookies are small files that are stored on your computer and are used to collect information while you visit the website.</p>
    <p>&nbsp;</p>
    <p>This cookie policy provides information on the cookies used on ZP&rsquo;s website, and how and why ZP uses the information collected by cookies.</p>
    <h2>
      <a name="_Toc63679334" />1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; HOW AND WHY DOES ZP USE THE INFORMATION?
    </h2>
    <p>ZP uses cookies to better understand how you use our website and collect statistics about your use of our website. In the long term, ZP uses this knowledge to improve the content and the services provided to the users and to optimize and further develop our website in accordance with the user&rsquo;s needs. Cookies may also improve the website's functionality upon your next visit to the website. The use of cookies is based on your consent. You can withdraw your consent at any time, in this case, you are suspending the use of the service.&nbsp;&nbsp;</p>
    <h2>
      <a name="_Toc63679335" />2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; THE INFORMATION WE COLLECT FROM YOU BY USING COOKIES
    </h2>
    <p>Examples of information collected through the use of cookies are browser information and your activities while on the website, such as IP-address, what third party sites that connects you to the website, the search words you use while at the website, the specific sites you visit at the website and the date and duration of the visit.</p>
    <p>
      As a visitor on our website, you will as a main rule remain anonymous. Note however that we collect the entire IP address. Your IP address is only stored for the duration of your visit at the website and will thereafter be either deleted or anonymized (the last digits of the number are removed). Your IP address is considered as personal data. More information about how we process personal data can be found in our <router-link to="privacy-policy">
        Privacy Policy
      </router-link>.
    </p>
    <h2>
      <a name="_Toc63679336" />3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; THE COOKIES WE USE
    </h2>
    <p>ZP currently uses the following cookies:&nbsp;</p>
    <p>&nbsp;</p>
    <table width="100%">
      <tbody>
        <tr>
          <td width="16%">
            <p>Type of Cookie</p>
          </td>
          <td width="69%">
            <p>Purpose of Cookie and data collected by the cookie</p>
            <p>&nbsp;</p>
          </td>
          <td width="14%">
            <p>Lifespan of the Cookie</p>
          </td>
        </tr>
        <tr>
          <td width="16%">
            <p>Google Analytics</p>
          </td>
          <td width="69%">
            <p>The purpose is web analytics service offered by Google Ireland Limited. (&ldquo;Google&rdquo;), to analyse how our website is used. This service uses cookies generating information on your use of our website (including your IP address), collected from Google in an anonymous form. Disabling these third-party cookies does not affect the website use. These cookies are used to collect information about how visitors use our website. We use the information to compile reports and to help us improve the website. The cookies collect information in an anonymous form, including the number of visitors to the website, where visitors have come to the website from and the pages they visited.</p>
          </td>
          <td width="14%">
            <p>&nbsp;</p>
          </td>
        </tr>
        <tr>
          <td width="16%">
            <p>Login credentials</p>
          </td>
          <td width="69%">
            <p>The purpose is to ease the login process, by remembering the credentials for sign-in details.</p>
          </td>
          <td width="14%">
            <p>&nbsp;</p>
          </td>
        </tr>
      </tbody>
    </table>
    <p>&nbsp;</p>
    <h2><a name="_Toc63679337" />4&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; HOW TO AVOID COOKIES</h2>
    <p>In order to detect and delete cookies, you can change the settings in your browser. The "Help" function of your browser can help you configure your browser to prevent cookies or delete existing cookies. You can also learn how to block all new cookies on your browser and which configuration steps are required to receive a notification about new cookies. However, please note that if you choose not to accept cookies, you may not be granted access to all functionality on the website.</p>
    <p>&nbsp;</p>
    <p>To opt out of Google Analytics, visit <a href="http://tools.google.com/dlpage/gaoptout">http://tools.google.com/dlpage/gaoptout</a>. You can also prevent data collection via Google Analytics on this website by clicking here. An "Opt-out Cookie" shall then be applied which shall prevent any future collection of the site visitor's data when visiting this website. Further information concerning data processing and use by Google, the settings and deactivation possibilities can be found in the Google Privacy Policy (<a href="https://policies.google.com/privacy">https://policies.google.com/privacy</a>) as well as in the Google Ads Settings (<a href="https://adssettings.google.com/authenticated">https://adssettings.google.com/authenticated</a>).</p>
    <p>&nbsp;</p>
    <h2><a name="_Toc63679338" />5&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; MODIFICATIONS TO THIS POLICY OR THE COOKIES USED BY ZP</h2>
    <p>Please be advised that the above list of cookies and this policy is subject to change. The cookie policy will show the current policy and list of cookies at all times. We recommend that you check the cookie policy from time to time, to keep up to date with the current policy and list of cookies.</p>
    <p>&nbsp;</p>
    <p>Please be advised that continued use of ZP&rsquo;s website following the posting of any changes of the policy shall constitute acceptance of such changes. Changes that require your consent will be disclosed through notifications in the website.</p>
    <p>&nbsp;</p>
    <p>***</p>
    <p>&nbsp;</p>
    <p>Last updated: 2021.02.08</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
  </div>  
</template>

<script>
export default {
  name: 'CookiesPolicy',
  metaInfo: {
    title: 'Cookies Policy – Djuli',
    meta: [{ name: 'description', content: 'Read the Djuli cookies policy.' }],
  },
  mounted() {
    document.dispatchEvent(new Event('render-event'));
  },
}
</script>

<style scoped>
.main{
  margin:auto;
  text-align: justify;
}
</style>